import FormattedMessage from 'I18n/components/FormattedMessage';
import { memo } from 'react';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { EditorPage } from 'foundations-components/transitional/components/EditorPage';
import NavigationBar from './NavigationBar';
import { CardSectionSettings } from './CardSectionSettings';
import { FastContext as InternalContextProvider } from '../../settings/store/context/FastContext';
import { CrmObjectBoardCardPreview } from '../CrmObjectBoardCardPreview';
import { Text } from 'foundations-components/components/Text';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/components/View';
import { usePreloadLoading } from 'crm-object-board-core/providers';
import { LoadingDots } from 'foundations-components/transitional/components/LoadingDots';
import { useCardSettingsOnClose, useIsCardSettingsPanelOpen } from '../../providers/settings/CardSettingsPanelProvider';
import { useCardSectionSettingsError } from '../../hooks/useCardSections';
import { useCardSectionSettingsLoading } from '../../hooks/useCardSections';
import { ErrorPage } from '../common/ErrorPage';
import { useDefaultCardSectionSettings } from '../../api/useDefaultCardSectionSettings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CardPreview = () => {
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "board-card-settings-preview",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "crmObjectBoardCard.settings.editor.preview"
      })
    }), /*#__PURE__*/_jsx(TFlex, {
      justify: "center",
      width: "100%",
      marginBlockStart: "800",
      children: /*#__PURE__*/_jsx("div", {
        style: {
          width: '280px'
        },
        children: /*#__PURE__*/_jsx(CrmObjectBoardCardPreview, {})
      })
    })]
  });
};
const InternalCrmObjectBoardCardSettings = /*#__PURE__*/memo(({
  onClose
}) => {
  const preLoading = usePreloadLoading();
  const cardSectionSettingsLoading = useCardSectionSettingsLoading();
  const cardSectionSettingsError = useCardSectionSettingsError();
  const {
    error: defaultSettingsError
  } = useDefaultCardSectionSettings();
  const isLoading = preLoading || cardSectionSettingsLoading;
  const hasError = !!cardSectionSettingsError || !!defaultSettingsError;
  return /*#__PURE__*/_jsx(Modal, {
    use: "fullscreen",
    children: /*#__PURE__*/_jsxs(EditorPage, {
      "data-test-id": "board-card-settings-editor-page",
      headerComponent: /*#__PURE__*/_jsx(NavigationBar, {
        onClose: onClose
      }),
      mainSectionFlush: true,
      use: "dark",
      children: [hasError && /*#__PURE__*/_jsx(ErrorPage, {}), !hasError && /*#__PURE__*/_jsxs(TFlex, {
        align: "stretch",
        justify: "start",
        blockSize: "100%",
        children: [/*#__PURE__*/_jsx(View, {
          as: "div",
          padding: "800",
          backgroundColor: 'fill-surface-recessed',
          inlineSize: "50%",
          children: isLoading ? /*#__PURE__*/_jsx(LoadingDots, {
            "data-test-id": "loading-dots"
          }) : /*#__PURE__*/_jsx(CardPreview, {})
        }), /*#__PURE__*/_jsx(View, {
          as: "div",
          padding: "800",
          backgroundColor: 'fill-surface-default',
          inlineSize: "50%",
          children: isLoading ? /*#__PURE__*/_jsx(LoadingDots, {
            "data-test-id": "loading-dots"
          }) : /*#__PURE__*/_jsx(CardSectionSettings, {})
        })]
      })]
    })
  });
});
const CrmObjectBoardCardSettings = () => {
  const isOpen = useIsCardSettingsPanelOpen();
  const onClose = useCardSettingsOnClose();
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/_jsx(InternalContextProvider, {
    children: /*#__PURE__*/_jsx(InternalCrmObjectBoardCardSettings, {
      onClose: onClose
    })
  });
};
export { CrmObjectBoardCardSettings };